export const envSecretValuesDev = {
  iframeModeKey: 'ffc56df2-fb86-436f-b016-1005ba56af74',
  encryptionPassphrase: '38b40bf0-a31e-492a-bba1-2597e06a99e9',
  googleApiKey: 'AIzaSyDzjrz16pdxEIm7fSLMXdqwoDuxA1ddTc4',
  googleTagManagerId: 'GTM-N3JZJBS',
};
